import { zustandImmerMiddleware } from '@sketchnote/shared-components';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { getDoc, getDocument } from '../api/useDocServices';
import { DocType } from '../types/doc';

export type DocStore = {
  docs: {
    [key: string]: ({ data?: DocType } & { isFetching?: boolean }) | null;
  };
  isVersionHistoryOpen: boolean;

  isDocumentEdited: boolean;
  setIsDocumentEdited: (value: boolean) => void;

  fetchDoc: (docId: string, isPublic?: boolean) => Promise<void>;
  fetchDocument: (docId: string) => Promise<void>;
};

export const useDocStore = create<
  DocStore,
  [['zustand/devtools', DocStore], ['zustand/immer', DocStore]]
>(
  devtools(
    zustandImmerMiddleware((set) => ({
      docs: {},
      isVersionHistoryOpen: false,
      fetchDoc: async (docId: string, isPublic?: boolean) => {
        set((state) => ({ ...state, isFetching: true }));
        set((state) => {
          const { docs } = state;
          docs[docId] = { ...docs[docId], isFetching: true };
        });
        const doc = await getDoc({ docId, isPublic });

        if (doc) {
          set((state) => {
            state.docs[docId] = { ...state.docs[docId], data: doc, isFetching: false };
          });
        }
      },

      fetchDocument: async (docId: string) => {
        set((state) => ({ ...state, isFetching: true }));
        set((state) => {
          const { docs } = state;
          docs[docId] = { ...docs[docId], isFetching: true };
        });
        const doc = await getDocument({ docId });

        if (doc) {
          set((state) => {
            state.docs[docId] = { ...state.docs[docId], data: doc, isFetching: false };
          });
        }
      },

      isDocumentEdited: false,
      setIsDocumentEdited: (value) =>
        set((s) => {
          s.isDocumentEdited = value;
        }),
    }))
  )
);
